import { render, staticRenderFns } from "./EmployeeCertificationView.vue?vue&type=template&id=4f4188e2&scoped=true&"
import script from "./EmployeeCertificationView.vue?vue&type=script&lang=js&"
export * from "./EmployeeCertificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4188e2",
  null
  
)

export default component.exports